import React from 'react'
import InfoSvg from 'images/modules/Manage/i-info-full.svg?raw'

export { default as InfoFullUrl } from 'images/modules/Manage/i-info-full.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: InfoSvg}} />
)
